import loadable from '@wix/yoshi-flow-editor/loadable'
import type {DatePickerInput as DatePickerInputType} from 'wix-ui-tpa/dist/cssVars/esm/components/DatePickerInput/DatePickerInput'

const DatePickerInput = loadable<DatePickerInputType>(
  async () =>
    import(
      /* webpackChunkName: "date-picker" */ 'wix-ui-tpa/dist/cssVars/esm/components/DatePickerInput/DatePickerInput'
    ),
  {
    resolveComponent: components => components.DatePickerInput,
  },
)

export default DatePickerInput
